<template>
  <v-card flat class="pa-4 w-100">
<!-- پاپ‌آپ نمایش تک‌کارته تجهیزات -->
<custom-popup
  v-model="showEquipmentDialog"
  :cons="{ title: 'جزئیات تجهیزات کیو‌آر', icon: 'mdi-package-variant' }"
  max-width="420"
>
  <v-card flat class="pa-4 text-center" v-if="selectedEquipment && selectedEquipment.item">
    
    <!-- عنوان کامل: ترکیب عنوان والد و خود محصول -->
    <div class="text-h6 font-weight-bold mb-1 primary--text">
      <template v-if="selectedEquipment.item.parent?.title">
        {{ selectedEquipment.item.parent.title }}
        <span class="grey--text text--lighten-1 mx-1">/</span>
      </template>
      <span>{{ selectedEquipment.item.title }}</span>
    </div>

    <div class="mb-4">
      <v-chip color="grey lighten-3" class="font-weight-bold px-3" small>
        شناسه: {{ selectedEquipment.item.id }}
      </v-chip>
    </div>

    <v-card outlined class="pa-3 rounded-xl grey lighten-5">
      <v-img
        v-if="selectedEquipment.item.image || selectedEquipment.item.parent?.image"
        :src="selectedEquipment.item.image || selectedEquipment.item.parent?.image"
        max-height="280"
        contain
        class="rounded-lg mx-auto"
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
          </v-row>
        </template>
      </v-img>
      
      <div v-else class="grey--text py-8">
        <v-icon size="48" color="grey lighten-2">mdi-image-off</v-icon>
        <div class="text-caption mt-2">تصویری یافت نشد</div>
      </div>
    </v-card>

  </v-card>
</custom-popup>

    <vue-table
      :data="data"
      :headers="headers"
      :loading.sync="loading"
      @change="onPagination"
    >
      <template v-slot:filters="{ props, perPage }">
        <v-row>
          <v-col cols="12" md="2">
            <v-combobox
              outlined
              class="rounded-lg"
              label="تعداد"
              dense
              :items="perPage"
              v-model="props.length"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              append-icon="mdi-magnify"
              class="rounded-lg"
              label="جستجو"
              outlined
              dense
              v-model="props.search"
            />
          </v-col>
          <v-col class="pa-2" cols="12" lg="3" md="3">
            <v-autocomplete
              v-model="props.status"
              append-icon="mdi-list-status"
              class="rounded-lg"
              clearable
              :items="items"
              item-text="text"
              @change="changestatus"
              item-value="value"
              dense
              :no-data-text="
                items.length === 0
                  ? 'هیچ وضعیتی وجود ندارد'
                  : 'در حال بارگذاری...'
              "
              hide-details
              label="وضعیت"
              outlined
              ><template v-slot:selection="{ item }">
                <v-icon left small color="primary">{{ item.icon }}</v-icon>
                {{ item.text }}
              </template>
              <template v-slot:item="{ item }">
                <v-icon left small color="primary">{{ item.icon }}</v-icon>
                {{ item.text }}
              </template>
            </v-autocomplete>
          </v-col>
          <v-col class="pa-2" cols="12" lg="3" md="3">
            <v-autocomplete
              v-model="props.type"
              append-icon="mdi-cash-multiple"
              class="rounded-lg"
              clearable
              :items="itemsType"
              item-text="text"
              @change="changeType"
              item-value="value"
              dense
              :no-data-text="
                items.length === 0 ? 'هیچ نوع وجود ندارد' : 'در حال بارگذاری...'
              "
              hide-details
              label="نوع"
              outlined
            >
              <template v-slot:selection="{ item }">
                <v-icon left small> {{ item?.icon }}</v-icon>
                <span>{{ item?.text }}</span>
              </template>
              <template v-slot:item="{ item }">
                <v-icon left small> {{ item?.icon }}</v-icon>
                <span>{{ item?.text }}</span>
              </template>
            </v-autocomplete>
          </v-col>
          <!-- فیلتر نحوه تحویل -->
<v-col class="pa-2" cols="12" lg="2" md="3">
  <v-autocomplete
    v-model="props.delivery_methode"
    append-icon="mdi-truck-delivery"
    class="rounded-lg"
    clearable
    :items="itemsDelivery"
    item-text="text"
    @change="changeDelivery"
    item-value="value"
    dense
    hide-details
    label="نحوه تحویل"
    outlined
  >
    <template v-slot:selection="{ item }">
      <v-icon left small color="primary">{{ item.icon }}</v-icon>
      {{ item.text }}
    </template>
    <template v-slot:item="{ item }">
      <v-icon left small color="primary">{{ item.icon }}</v-icon>
      {{ item.text }}
    </template>
  </v-autocomplete>
</v-col>

<!-- فیلتر مرتب‌سازی -->
<v-col class="pa-2" cols="12" lg="2" md="3">
  <v-select
    v-model="props.dir"
    :items="itemsSort"
    item-text="text"
    item-value="value"
    @change="changeSort"
    class="rounded-lg"
    dense
    hide-details
    label="مرتب‌سازی"
    outlined
  >
    <template v-slot:selection="{ item }">
      <v-icon left small color="primary">{{ item.icon }}</v-icon>
      <span class="text-truncate" style="max-width: 100px;">{{ item.text }}</span>
    </template>
    <template v-slot:item="{ item }">
      <v-icon left small color="primary">{{ item.icon }}</v-icon>
      {{ item.text }}
    </template>
  </v-select>
</v-col>

          <!-- <v-col cols="12" md="3" >
                <v-combobox v-model="props" />
            </v-col> -->
        </v-row>
      </template>

      <template v-slot:index="{ item }">
        {{ persian(item.index + 1 + (data.current_page - 1) * data.per_page) }}
      </template>

      <template v-slot:user_fullname="{ item }">
          {{ item.user ? (item.user.name + " " + item.user.lastName) : "-" }}
      </template>

      <template v-slot:type="{ item }">
        <v-chip :color="typeText(item.type).color" small>
          <v-icon left :color="typeText(item.type).color" x-small>
            {{ typeText(item.type).icon }}
          </v-icon>
          {{ typeText(item.type).text }}
        </v-chip>
      </template>

      <template v-slot:province_city="{ item }">
        {{ item?.province ?? "-" }} / {{ item?.city ?? "-" }}
      </template>

      <template v-slot:address="{ item }">
        <v-tooltip bottom color="light-blue-lighten-4">
          <template v-slot:activator="{ on }">
            <span v-on="on" class="text-truncate">{{
              item.address ?? "-"
            }}</span>
          </template>
          <span>{{ item.address ?? "-" }}</span>
        </v-tooltip>
      </template>

      <template v-slot:qr_id="{ item }">
        {{ persian(item.qr_id) || "-" }}
      </template>

      <template v-slot:postal_code="{ item }">
        {{ persian(item.postal_code) || "-" }}
      </template>

      <template v-slot:created_at="{ item }">
        {{ toJalaliDateTime(item.created_at) || "-" }}
      </template>

      <template v-slot:status="{ item }">
        <v-chip :color="sateText(item.status).color" small>
          <v-icon left :color="sateText(item.status).color" x-small>
            {{ sateText(item.status).icon }}
          </v-icon>
          {{ sateText(item.status).text }}
        </v-chip>
      </template>

      <template v-slot:manage="{ item }">
        <manage-button
          :data="item"
          :meta="getMetaButtons(item)"
          v-if="item.status !== 'canceled'"
        />
        <div v-if="item.status === 'canceled'">
          <v-icon left small>mdi-close</v-icon>
        </div>
      </template>

<template v-slot:equipment_cart="{ item }">
  <v-btn
    v-if="item.item"
    color="primary"
    text
    small
    class="font-weight-bold"
    @click="openEquipmentModal(item)"
  >
    <v-icon small left>mdi-image-outline</v-icon>
    {{ item.item.parent ? item.item.parent.title + ' / ' : '' }}{{ item.item.title }}
  </v-btn>
  <span v-else class="grey--text text--lighten-1">-</span>
</template>
    </vue-table>
  </v-card>
</template>

<script>
import manageButton from "@/view/pages/button.vue";
import moment from "moment-jalaali";
export default {
  name: "equipmentList",
  components: { manageButton },
  data() {
    return {
      showEquipmentDialog: false,
      selectedEquipment: null,
      headers: [
        { value: "index", text: "ردیف", align: "center", sortable: false },
        // {
        //   value: "user_id",
        //   text: "شناسه کاربر",
        //   align: "center",
        //   sortable: false,
        // },
        {
          value: "user_fullname",
          text: "نام/ نام خانوادگی",
          align: "center",
          sortable: false,
        },
        {
          value: "qr_id",
          text: "شناسه کیوآر",
          align: "center",
          sortable: false,
        },
        { value: "type", text: "نوع", align: "center", sortable: false },
        // { value: "province", text: "استان", align: "center", sortable: false },
        {
          value: "province_city",
          text: "استان/ شهر",
          align: "center",
          sortable: false,
        },
        { value: "address", text: "آدرس", align: "center", sortable: false },
        {
          value: "postal_code",
          text: "کد پستی",
          align: "center",
          sortable: false,
        },
        {
          value: "equipment_cart",
          text: "تجهیزات",
          align: "center",
          sortable: false,
        },
        {
          value: "count",
          text: "تعداد",
          align: "center",
          sortable: false,
        },
        { value: "status", text: "وضعیت", align: "center", sortable: false },
        {
          value: "created_at",
          text: "زمان ثبت سفارش",
          align: "center",
          sortable: false,
        },
        { value: "manage", text: "مدیریت", align: "center", sortable: false },
      ],
      tableProps: {
        page: 1,
        search: "",
        length: 10,
        to: 1,
        status: null, 
        type: null,
       delivery_methode: null,
        column: "updated_at",  
        dir: "desc",
      },
       itemsDelivery: [
        { text: "همه", value: null, icon: "mdi-filter" },
        { text: "تحویل از شرکت", value: "company", icon: "mdi-domain" },
        { text: "پست", value: "post", icon: "mdi-truck" },
      ],
      itemsSort: [
        { text: "جدیدترین سفارش", value: "desc", icon: "mdi-sort-clock-descending-outline" },
        { text: "قدیمی‌ترین سفارش", value: "asc", icon: "mdi-sort-clock-ascending-outline" },
      ],
         itemsType: [
      { text: "همه", value: null, icon: "mdi-filter" },
      { text: "رایگان", value: "free", icon: "mdi-gift" },
      { text: "پولی", value: "special", icon: "mdi-cash-multiple" },
    ],
    
      loading: false,
      data: {},
      items: [
        { text: "همه", value: null, icon: "mdi-filter" },
        { text: "ارسال شده", value: "shipped", icon: "mdi-truck" },
        { text: "پرداخت شده", value: "paid", icon: "mdi-cash-check" },
        { text: "تحویل شده", value: "delivered", icon: "mdi-check" },
        { text: "رد شده", value: "canceled", icon: "mdi-close" },
      ],
    };
  },

  mounted() {
    this.fetch();
  },

  methods: {
      openEquipmentModal(item) {
    if (!item || !item.item) return;
    this.selectedEquipment = item;
    this.showEquipmentDialog = true;
  },
     changestatus(value) {
    this.tableProps.status = value === "" ? null : value;
    this.tableProps.page = 1;
    this.fetch();
  },

  changeType(value) {
    this.tableProps.type = value === "" ? null : value;
    this.tableProps.page = 1;
    this.fetch();
  },

  changeDelivery(value) {
    this.tableProps.delivery_methode = value === "" ? null : value;
    this.tableProps.page = 1;
    this.fetch();
  },

  changeSort(value) {
    this.tableProps.dir = value;
    this.tableProps.page = 1;
    this.fetch();
  },
    async fetch(params = this.tableProps) {
      try {
        this.loading = true;
        await this.$api
          .get("/admin/qr-equipment/orders", { params })
          .then(({ data }) => {
            this.data = data.data;
          });
      } catch {
      } finally {
        this.loading = false;
      }
    },

    changestatus(value) {
      this.tableProps.status = value === "" ? null : value;
    },

    onPagination(e) {
      if (e !== this.tableProps.page) {
        this.tableProps.page = e.page;
        this.tableProps.length = e.length;
        this.tableProps.search = e.search;
        this.$nextTick(() => {
          this.fetch();
        });
      }
    },

    typeText(value) {
      switch (value) {
        case "free":
          return { text: "رایگان", color: "teal-lighten-3", icon: "mdi-gift" };
        case "special":
          return {
            text: "پولی",
            color: "light-blue-lighten-3",
            icon: "mdi-cash-multiple",
          };
        default:
          return { text: value, color: "grey-lighten-2", icon: "mdi-cash" };
      }
    },

    toJalaliDateTime(gregorianDate) {
      try {
        return moment(gregorianDate)
          .locale("fa")
          .format("jYYYY/jMM/jDD HH:mm:ss");
      } catch (error) {
        console.error("Error converting date:", error);
        return "-";
      }
    },

    sateTextmeta(state) {
      switch (state) {
        case "shipped":
          return {
            text: "ارسال شده",
            color: "teal-lighten-4",
            icon: "truck",
          };
        case "paid":
          return {
            text: "پرداخت شده",
            color: "amber-lighten-3",
            icon: "cash-check",
          };
        case "delivered":
          return {
            text: "تحویل شده",
            color: "cyan-lighten-4",
            icon: "check",
          };
        case "canceled":
          return {
            text: "رد شده",
            color: "red-lighten-4",
            icon: "fa-ban",
          };
        default:
          return {
            text: state,
            color: "grey-lighten-3",
            icon: "help-circle",
          };
      }
    },

    getMetaButtons(item) {
      const statusMap = {
        paid: "shipped",
        shipped: "delivered",
        delivered: "delivered",
        canceled: "canceled",
      };
      const nextStatus = statusMap[item.status] || "canceled";
      const nextStatusText = this.sateTextmeta(nextStatus);
      return {
        buttons: [
          {
            text: nextStatusText.text,
            color: "success",
            label: `تغییر وضعیت به ${nextStatusText.text}`,
            icon: nextStatusText.icon,
            class: "btn-accept rounded-pill",
            action: (data) => this.action(data, "change_status"),
          },
          {
            text: "رد کردن",
            label: "رد کردن",
            icon: "ban",
            class: "btn-outline-danger",
            action: (data) => this.action(data, "canceled"),
          },
        ],
      };
    },

    sateText(state) {
      console.log("status", state);

      switch (state) {
        case "shipped":
          return {
            text: "ارسال شده",
            color: "teal-lighten-4",
            icon: "mdi-truck",
          };
        case "paid":
          return {
            text: "پرداخت شده",
            color: "amber-lighten-3",
            icon: "mdi-cash-check",
          };
        case "delivered":
          return {
            text: "تحویل شده",
            color: "cyan-lighten-4",
            icon: "mdi-check",
          };
        case "canceled":
          return { text: "رد شده", color: "red-lighten-4", icon: "mdi-close" };
        default:
          return {
            text: state,
            color: "grey-lighten-3",
            icon: "mdi-help-circle",
          };
      }
    },

    StatusCheck(item) {
      this.loading = true;
      const statusMap = {
        shipped: "delivered",
        paid: "shipped",
        delivered: "delivered",
        canceled: "canceled",
      };
      const status = statusMap[item.status] || "canceled";
      if (!status) return;
      this.$api
        .post(`/admin/qr-equipment/order/${item.id}`, {
          status: status,
        })
        .then(({ data }) => {
          this.loading = false;

          const t = this.sateText(status).text;
          this.$toast.success(`سفارش با موفقیت تغییر وضعیت به ${t} یافت.`);
          this.fetch();
        })
        .catch((error) => {
          this.loading = false;
          this.$toast.error(" خطا در تغییر وضعیت");
          console.error(error);
        })
        .finally(() => {});
    },

    canceled(data) {
      this.loading = true;
      this.$api
        .post(`/admin/qr-equipment/order/${data.id}`, {
          status: "canceled",
        })
        .then(({ data }) => {
          this.loading = false;
          this.$toast.success("سفارش با موفقیت رد شد");

          this.fetch();
        })
        .catch((error) => {
          this.loading = false;
          this.$toast.error("خطا در رد کردن سفارش");
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    action(data, type) {
      switch (type) {
        case "change_status":
          this.StatusCheck(data);
          break;
        case "canceled":
          this.canceled(data);
        default:
          break;
      }
    },
  },
};
</script>

<style scoped>
.text-truncate {
  display: -webkit-box;
  text-overflow: ellipsis;
  max-width: 200px;
  vertical-align: middle;
  width: 100%;
  box-sizing: border-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}
.teal-lighten-3 {
  background-color: #80cbc4 !important;
  color: #fff !important;
}
.light-blue-lighten-3 {
  background-color: #4fc3f7 !important;
  color: #fff !important;
}
.grey-lighten-2 {
  background-color: #eeeeee !important;
  color: #424242 !important;
}
.teal-lighten-4 {
  background-color: #b2dfdb !important;
  color: #fff !important;
}
.amber-lighten-3 {
  background-color: #ffe082 !important;
  color: #424242 !important;
}
.cyan-lighten-4 {
  background-color: #b2ebf2 !important;
  color: #fff !important;
}
.red-lighten-4 {
  background-color: #ffcdd2 !important;
  color: #fff !important;
}
.grey-lighten-3 {
  background-color: #f5f5f5 !important;
  color: #424242 !important;
}
.image-box {
  background-color: #fafafa;
  border-radius: 8px;
  padding: 4px;
}
</style>
